"use client";

import { c as _c } from "react/compiler-runtime";
import { PROFILE_ACTIVITY_TYPE_TO_TEXT } from "@/entities/IProfile";
import { ProfileActivityLogType } from "@/enums";
import { useEffect, useState } from "react";
import ProfileActivityLogsIcon from "../icons/ProfileActivityLogsIcon";
export default function ProfileActivityLogsFilterListItem(t0) {
  const $ = _c(24);
  const {
    itemType,
    selectedItems,
    setSelected
  } = t0;
  let t1;
  if ($[0] !== itemType || $[1] !== selectedItems) {
    t1 = selectedItems.includes(itemType);
    $[0] = itemType;
    $[1] = selectedItems;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [isSelected, setIsSelected] = useState(t1);
  let t2;
  if ($[3] !== itemType || $[4] !== selectedItems) {
    t2 = () => {
      setIsSelected(selectedItems.includes(itemType));
    };
    $[3] = itemType;
    $[4] = selectedItems;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== selectedItems) {
    t3 = [selectedItems];
    $[6] = selectedItems;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  useEffect(t2, t3);
  let t4;
  if ($[8] !== itemType || $[9] !== setSelected) {
    t4 = () => setSelected(itemType);
    $[8] = itemType;
    $[9] = setSelected;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== itemType) {
    t5 = <ProfileActivityLogsIcon logType={itemType} />;
    $[11] = itemType;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = PROFILE_ACTIVITY_TYPE_TO_TEXT[itemType];
  let t7;
  if ($[13] !== t6) {
    t7 = <span className="tw-font-normal tw-block tw-truncate">{t6}</span>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t5 || $[16] !== t7) {
    t8 = <div className="tw-w-full tw-flex tw-items-center tw-space-x-3 tw-pr-4">{t5}{t7}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== isSelected) {
    t9 = isSelected && <span className="tw-text-iron-50 tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center tw-pr-4"><svg className="tw-h-4 tw-w-4 tw-text-primary-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" /></svg></span>;
    $[18] = isSelected;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t4 || $[21] !== t8 || $[22] !== t9) {
    t10 = <li><button className="tw-bg-transparent tw-border-none tw-w-full tw-h-full tw-group tw-text-iron-50 tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-py-2.5 tw-pl-3 tw-pr-9 hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out" onClick={t4}>{t8}{t9}</button></li>;
    $[20] = t4;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
}